import heic2any from 'heic2any';

const HEIC_TYPES = ['image/heic', 'image/heif'];
const HEIC_EXTENSIONS = ['.heic', '.heif'];

function isHeic(file: File): boolean {
	if (HEIC_TYPES.includes(file.type.toLowerCase())) return true;
	const ext = file.name.toLowerCase().split('.').pop();
	return ext ? HEIC_EXTENSIONS.includes(`.${ext}`) : false;
}

/**
 * Converts HEIC/HEIF files to JPEG. Passes through all other files unchanged.
 */
export async function convertImageIfNeeded(file: File): Promise<File> {
	if (!isHeic(file)) return file;

	const blob = await heic2any({
		blob: file,
		toType: 'image/jpeg',
		quality: 0.9,
	});

	const result = Array.isArray(blob) ? blob[0] : blob;
	const newName = file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg');
	return new File([result], newName, { type: 'image/jpeg' });
}

/**
 * Converts an array of files, converting any HEIC files to JPEG.
 */
export async function convertImagesIfNeeded(files: File[]): Promise<File[]> {
	return Promise.all(files.map(convertImageIfNeeded));
}
